import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

import { commicIllustrationImg2 } from "../../asserts/images";

const CommicIllustration = () => {
  return (
    <>

    <Helmet>
        <meta charSet="utf-8" />
        <title>
            Top Comic Book Illustration Services for Hire
        </title>
        <meta
          name="description"
          content="Hire top comic book illustrators with Falcon Book Writing to create stunning, professional artwork that brings your characters and stories to life."
        />
        <meta name="keywords" content="Comic Book Illustration" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


      <UserLayout>
        <InnerHero
          innerheroclass="commicIllustrationBg"
          title="Professional"
          subtitle=" Comic Book Illustration "
          title2="That Grabs Attention Instantly"
          para="Bring your comic book to life with professional illustrations that command attention. Every panel, character, and scene is crafted with precision, energy, and style, delivering visually stunning artwork that captivates readers from the very first page."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section"
          title="Dynamic Comic Art That Brings  "
          subtitle="  Stories "
          title2="to Life"
          // subtitle1="How we work?"
          description="Comic books are a unique blend of storytelling and visual art, where every panel matters. Our dynamic comic book illustration services transform scripts into vivid, action-packed visuals that capture the energy, emotion, and essence of your story. Each character, setting, and scene is meticulously crafted to engage readers, making them feel every punch, chase, and dramatic moment. We focus on composition, perspective, and color to ensure every frame pops with life, while maintaining consistency and style throughout the book. Whether your story is a superhero saga, a thrilling adventure, or a heartfelt tale, our illustrations bring it to life, enhancing narrative impact and reader immersion. With professional comic art, your story becomes an unforgettable visual experience that resonates long after the final page."
          // subtitle2="    Tailored Collaborations?"
          // subtitle3="  Expert Guidance"
          image={commicIllustrationImg2}
          imgClass="commicIllustrationImg2"
          actions={true}
          btn1="Let’s Get Start"
          btn2="Call Us Now"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default CommicIllustration;
